import * as mixpanel from "mixpanel-browser";

import { MixpanelEvent } from "./types";

const runtimeEnv = process.env.RUNTIME_ENV ?? "development";

const projectToken =
  runtimeEnv === "production"
    ? "d242e1c7b1b5f47aef7ca13f3b053425"
    : "11e3c6523fb9d178642478483dabdf0f";

mixpanel.init(projectToken, { debug: runtimeEnv !== "production" });

const actions = {
  register: (props: Record<string, unknown>) => mixpanel.register(props),
  track: ({ name, props }: MixpanelEvent) => mixpanel.track(name, props),
};

export const Mixpanel = actions;
